import React, { useState } from "react";

import { Alert, Button, Checkbox, Input, ToggleChips } from "../../Ui/index.jsx";
import { apiRequest } from "../../Api/Client.js";
import onboardingVideo from "../../Onboarding.mp4";
import { CulturePoints } from "../hiring/index.js";
import { errorText } from "../../Shared/uiStyles.js";
import { WEEKDAYS, WELCOME_QUESTIONS, hoursProblem, seniorityOf, toggleDay, trackOf } from "./gettingStarted.js";

// The forms a step of the Getting started card opens into. Each is mounted only while open, so it starts fresh.

const DAY_OPTIONS = WEEKDAYS.map((name, day) => ({ value: day, label: name }));

export function WorkingHoursForm({ saved, slackAvailable, onSaved }) {
  const [start, setStart] = useState(saved?.start || "10:00");
  const [end, setEnd] = useState(saved?.end || "18:00");
  const [weekdays, setWeekdays] = useState(saved?.weekdays || [0, 1, 2, 3, 4]);
  const [announce, setAnnounce] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const save = async () => {
    const problem = hoursProblem({ start, end, weekdays });
    if (problem) { setError(problem); return; }
    setBusy(true);
    setError("");
    try {
      onSaved(await apiRequest("/Users/EmployeeProfiles/working-hours/", { method: "PUT", body: { start, end, weekdays, announce } }));
    } catch (err) {
      setError(errorText(err, "Could not save your hours. Please try again."));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="Gs-Form">
      <ToggleChips label="Days you work" options={DAY_OPTIONS} value={weekdays} onToggle={(day) => setWeekdays(toggleDay(weekdays, day))} chipClassName="Gs-Day" />
      <div className="Gs-Hours">
        <Input type="time" aria-label="From" value={start} onChange={(e) => setStart(e.target.value)} />
        <span>to</span>
        <Input type="time" aria-label="To" value={end} onChange={(e) => setEnd(e.target.value)} />
      </div>
      {slackAvailable ? <Checkbox className="Gs-Check" label="Tell the team on Slack" checked={announce} onChange={(e) => setAnnounce(e.target.checked)} /> : null}
      {error ? <Alert tone="danger">{error}</Alert> : null}
      <div><Button variant="primary" onClick={save} disabled={busy}>{busy ? "Saving…" : "Save my hours"}</Button></div>
    </div>
  );
}

export function ConfirmRead({ label, busy, onConfirm, children }) {
  const [ticked, setTicked] = useState(false);
  return (
    <div className="Gs-Form">
      {children}
      <Checkbox className="Gs-Check" label={label} checked={ticked} onChange={(e) => setTicked(e.target.checked)} />
      <div><Button variant="primary" disabled={!ticked || busy} onClick={onConfirm}>{busy ? "Saving…" : "Confirm"}</Button></div>
    </div>
  );
}

export function Welcome({ busy, onConfirm }) {
  const [acks, setAcks] = useState({});
  const all = WELCOME_QUESTIONS.every((q) => acks[q.id]);
  return (
    <div className="Gs-Form">
      <div className="Gs-Video">
        <video src={onboardingVideo} controls controlsList="nodownload" preload="none" />
      </div>
      {WELCOME_QUESTIONS.map((q) => (
        <Checkbox key={q.id} className="Gs-Check" label={q.text} checked={Boolean(acks[q.id])} onChange={(e) => setAcks({ ...acks, [q.id]: e.target.checked })} />
      ))}
      <div><Button variant="primary" disabled={!all || busy} onClick={onConfirm}>{busy ? "Saving…" : "Confirm"}</Button></div>
    </div>
  );
}

export function Culture({ employee, busy, onConfirm }) {
  const [checked, setChecked] = useState({});
  return (
    <div className="Cc-Wrap is-embedded Gs-Form">
      <CulturePoints
        track={trackOf(employee?.department_family)} seniority={seniorityOf(employee?.employment_type)} joined
        checked={checked} onToggle={(id) => setChecked((c) => ({ ...c, [id]: !c[id] }))} busy={busy} onContinue={onConfirm} continueLabel="Confirm"
      />
    </div>
  );
}
